<template>
  <div v-if="paymentLoading">
    <b-spinner variant="primary" label="Spinning"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "GoCardlessPayment",
  props: {
    amount: {
      type: String,
      required: true
    },
    gtagReference: {
      type: String,
      required: true
    },
    isCredit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      paymentLoading: false,
      handler: null,
      isProcessing: false,
      responseError: false,
      responseSuccess: false
    };
  },
  methods: {
    resetPayment() {
      this.responseError = false;
      this.responseSuccess = false;
    },
    loadPayment(secret) {
      this.responseSuccess = false;
      this.setHandler(secret);
    },
    setHandler(id) {
      this.handler = window.GoCardlessDropin.create({
        billingRequestFlowID: id,
        environment: process.env.VUE_APP_GOCARDLESS_ENV, // either live or sandbox
        onSuccess: () => {
          this.isProcessing = false;
          this.responseSuccess = true;
          const title = "Payment Processing";
          const subtitle = "Your payment will appear on your dashboard shortly";
          const samePage = true;
          this.$store.dispatch("pushSuccess", {
            title,
            subtitle,
            samePage
          });
          this.$emit("complete");
        },
        onExit: () => {
          this.isProcessing = false;
          if (!this.responseSuccess) {
            const title = "Payment Error";
            const subtitle =
              "We were unable to complete your payment, please try again";
            const samePage = true;
            this.$store.dispatch("pushError", { title, subtitle, samePage });
          }

          this.responseSuccess = false;
          this.$emit("error");
        }
      });

      this.handler.open();
    }
  }
};
</script>

<style scoped lang="scss"></style>
